import { createTheme } from '@konrady/ui-components';

const theme = createTheme({
	// replacing fonts with default ones, to load webfonts asynchronously
	fonts: {
		// body: 'system-ui, sans-serif',
		body: 'Menlo, monospace',
		heading: 'inherit',
		mono: 'Menlo, monospace',
	},
});

export default theme;
